import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, forkJoin, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FetchDataService {
  private assetBasePath = `/assets/${environment.projectName}/content/`;
  private dashboardBasePath = `/assets/`;
  private configPath = `/config/config.json`;
  private stylePath = `/assets/${environment.projectName}/style.json`;

  constructor(private http: HttpClient) {}

  getJsonData(lang: string, pageName: string, fileName: string): Observable<any[]> {
    const url = `${this.assetBasePath}${lang}/${pageName}/${fileName}.json`;
    return this.http.get<any[]>(url);
  }

  getJSONServicesByFileName(
    projectName: string,
    pageName: string,
    filename: string
  ): Observable<any[]> {
    const languages = ['en', 'ar', 'de'];
    const requests = languages.map((lang) =>
      this.http
        .get<any>(
          `${this.dashboardBasePath}${projectName}/content/${lang}/${pageName}/${filename}.json`
        )
        .pipe(
          catchError((error) => {
            console.error('Error fetching file:', error);
            return of(null);
          })
        )
    );
    return forkJoin(requests);
  }

  updateJsonData(
    projectName: string,
    pageName: string,
    filename: string,
    id: number,
    lang: string,
    data: any
  ): Observable<any> {
    const url = `http://localhost:5000/update/${projectName}/content/${lang}/${pageName}/${filename}.json`;
    const payload = { id, data };
    return this.http.post(url, payload);
  }

  getConfigFile(): Observable<any> {
    return this.http.get<any[]>(this.configPath);
  }

  getJSONfooter(): Observable<any> {
    return this.http.get<any[]>(`${this.assetBasePath}common/footer.json`);
  }

  getJSONheader(): Observable<any> {
    return this.http.get<any[]>(`${this.assetBasePath}common/header.json`);
  }

  getSocialLinks(): Observable<any> {
    return this.http.get<any[]>(`${this.assetBasePath}common/socialMediaLinks.json`);
  }

  loadStyles(): Observable<any> {
    return this.http.get<any>(this.stylePath);
  }
}
